import { createStore } from '@stencil/store';
// Read more about how stencil stores work here: https://stenciljs.com/docs/stencil-store

const { state, onChange } = createStore({
  selectedUrl: '',
  selectedType: '',
  selectedProfile: '',
  i18n: {
    choosenCompanyText: '',
    toText: '',
    chooseCustomerNumberText: '',
  },
});

export { state, onChange };
export default state;
